export const WORK_STRUCTURE_TYPE = "עבודה" as const;
export const WORKS_PATH = "/works";
export const WORKS_BREADCRUMB = { ledger: "כרטסות", list: "עבודות" } as const;
export const WORKS_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;